<template>
  <van-popup
    v-model="visible"
    position="bottom"
    closeable
    round
    close-icon="close"
    style="min-height: 40%"
  >
    <RecordDetail ref="recordDetailRef" :expoId="expoId" :visible="visible" />
  </van-popup>
</template>

<script>
import { Popup, Empty } from 'vant';
import RecordDetail from './RecordDetail.vue';

export default {
  name: 'RecordList',
  components: {
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    RecordDetail,
  },
  props: {
    expoId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('close');
      }
    },
  },
  methods: {
    triggerVisible(visible) {
      this.visible = visible;
    },
  },
};
</script>

<style lang="scss" scoped>
.record {
  padding: 16px;
  .record_list {
    overflow: auto;
    padding: 6px 0;
    color: #616161;
  }
  .record_item {
    display: flex;
    align-items: center;
  }
  .record_title {
    padding-bottom: 6px;
    border-bottom: 1px #eee solid;
  }
  .record_td {
    width: 33%;
    text-align: center;
  }
  .record-title {
    padding-bottom: 12px;
    border-bottom: 1px solid #b7b7b7;
  }
  .record_item + .record_item {
    margin-top: 16px;
  }
  .fs_10 {
    font-size: 10px;
  }
}
</style>
